import React, { createContext, useState } from 'react';
import { getSavedInterfaceLanguage } from '../i18n';

// Create the context
const SharedStateContext = createContext();

// Claude: bugfix reported during UAT — "clicking on a word that was found, and then on 'back',
// Claude: the empty search page is displayed. It would be better to return to the results page."
// Claude: LandingPage.js/AdvancedSearch.js kept their search form + results purely in local
// Claude: component state; React Router unmounts a route's component when navigating away from it
// Claude: (to /phrase/:id) and remounts a fresh one on the way back, so that state was simply gone.
// Claude: SharedStateContext already sits above the router (see App.js) and survives route changes,
// Claude: so it's the natural place to remember the last search per page — each search page reads
// Claude: its initial state from here and writes back whenever a search actually runs (not on every
// Claude: keystroke; see LandingPage.js/AdvancedSearch.js).
const DEFAULT_LANDING_SEARCH = {
  searchTerm: '', sourceLanguage: 'Eng', targetLanguage: 'All', partialMatch: false, fuzzyMatch: false, phrases: [],
};
const DEFAULT_ADVANCED_SEARCH = {
  searchTerm: '', sourceLanguage: 'Eng', targetLanguage: 'All', partialMatch: false, fuzzyMatch: false,
  // Claude: alpha-tester feedback — the default should be "Any status" (t("allstatus")), not
  // Claude: "Accepted" only, so a fresh advanced search doesn't silently hide pending/flagged terms.
  field: 'All', status: 'All', phrases: [],
};

// Create a provider component
export const SharedStateProvider = ({ children }) => {
//   const [sharedState, setSharedState] = useState('Initial State');
  // Claude: restores the saved interface language on reload (see getSavedInterfaceLanguage in
  // Claude: i18n.js) so the navbar dropdown and About/Contact/manual content match the i18next
  // Claude: language; falls back to the original 'Eng' default when nothing valid is saved.
  const [interfaceLanguage, setInterfaceLanguage] = useState(() => getSavedInterfaceLanguage() || 'Eng')
  const [landingSearch, setLandingSearch] = useState(DEFAULT_LANDING_SEARCH);
  const [advancedSearch, setAdvancedSearch] = useState(DEFAULT_ADVANCED_SEARCH);
  return (
    <SharedStateContext.Provider value={{
      interfaceLanguage, setInterfaceLanguage,
      landingSearch, setLandingSearch,
      advancedSearch, setAdvancedSearch,
    }}>
      {children}
    </SharedStateContext.Provider>
  );
};

export default SharedStateContext;  
